/**
 * presenceService.js
 * Axios wrappers for the real-time User Presence / Monitoring API.
 */

import api from './axiosInstance';

// Called every ~30s by any logged-in client.
export const sendHeartbeat = (payload) =>
  api.post('/admin/presence/heartbeat', payload);

// Called on tab close / explicit logout.
export const sendOffline = () =>
  api.post('/admin/presence/offline');

// Admin: list currently online users + page grouping.
export const getOnlineUsers = () =>
  api.get('/admin/presence/online');

// Admin: combined counters (online now + today's action counts).
export const getPresenceStats = () =>
  api.get('/admin/presence/stats');

// Admin: reconstruct a single user's activity into session timeline.
export const getUserJourney = (userId, params = {}) =>
  api.get(`/admin/presence/journey/${userId}`, { params });
